import { createReducer } from '@reduxjs/toolkit';
import type { IDrawingBase } from 'types/IDrawingBase';
import { fetchDrawingBases, fetchDrawingBase, createDrawingBase, updateDrawingBase, deleteDrawingBase } from 'store/actions/drawingBaseActions';

export interface DrawingBaseState {
  drawingBases: IDrawingBase[];
  selectedDrawingBase: IDrawingBase | null;
  loading: boolean;
  error: string | null;
}

const initialState: DrawingBaseState = {
  drawingBases: [],
  selectedDrawingBase: null,
  loading: false,
  error: null,
};

const drawingBaseReducer = createReducer<DrawingBaseState>(initialState, (builder) => {
  builder
    .addCase(fetchDrawingBases.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchDrawingBases.fulfilled, (state, action) => {
      state.loading = false;
      state.drawingBases = action.payload;
    })
    .addCase(fetchDrawingBases.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload?.message || 'Fehler beim Laden der Ziehungsbasen';
    })
    .addCase(fetchDrawingBase.fulfilled, (state, action) => {
      state.selectedDrawingBase = action.payload;
    })
    .addCase(createDrawingBase.fulfilled, (state, action) => {
      state.drawingBases.push(action.payload);
    })
    .addCase(updateDrawingBase.fulfilled, (state, action) => {
      const index = state.drawingBases.findIndex((d) => d.id === action.payload.id);
      if (index >= 0) state.drawingBases[index] = action.payload;
    })
    .addCase(deleteDrawingBase.fulfilled, (state, action) => {
      state.drawingBases = state.drawingBases.filter((d) => d.id !== action.meta.arg);
    });
});

export default drawingBaseReducer;
